var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHandRaised(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-tfx-c275": "",
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-6 h-6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-tfx-c275": "",
    d: "M17.116 11.0625V4.96875C17.116 4.34715 17.3629 3.75101 17.8025 3.31147C18.242 2.87193 18.8381 2.625 19.4597 2.625C20.0813 2.625 20.6775 2.87193 21.117 3.31147C21.5566 3.75101 21.8035 4.34715 21.8035 4.96875V14.8125C21.8035 16.0436 21.561 17.2627 21.0899 18.4002C20.6187 19.5376 19.9282 20.5711 19.0576 21.4416C18.1871 22.3122 17.1536 23.0027 16.0161 23.4739C14.8787 23.945 13.6596 24.1875 12.4285 24.1875C7.25082 24.1875 4.92849 21.375 1.11186 13.3226C0.957661 13.0561 0.857506 12.7617 0.817119 12.4564C0.776731 12.1512 0.796904 11.8409 0.876483 11.5434C0.956062 11.2459 1.09349 10.967 1.2809 10.7227C1.46832 10.4783 1.70206 10.2733 1.96875 10.1193C2.23544 9.96534 2.52987 9.86543 2.83519 9.8253C3.14051 9.78517 3.45075 9.8056 3.74818 9.88543C4.0456 9.96526 4.32438 10.1029 4.56858 10.2905C4.81277 10.4782 5.0176 10.7121 5.17135 10.9789L7.74099 15.4296V3.09375C7.74099 2.47215 7.98792 1.87601 8.42745 1.43647C8.86699 0.99693 9.46313 0.75 10.0847 0.75C10.7063 0.75 11.3025 0.99693 11.742 1.43647C12.1816 1.87601 12.4285 2.47215 12.4285 3.09375V11.0625",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "darkgoldenrod",
    fill: "gold"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-tfx-c275": "",
    transform: "translate(11 0)",
    d: "M6.11609 13.0625V3.21875C6.11609 2.59715 5.86916 2.00101 5.42962 1.56147C4.99008 1.12193 4.39394 0.875 3.77234 0.875C3.15074 0.875 2.5546 1.12193 2.11506 1.56147C1.67552 2.00101 1.42859 2.59715 1.42859 3.21875V13.0625",
    stroke: "darkgoldenrod",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "gold"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHandRaised);
export default __webpack_public_path__ + "static/media/icon_hand_raised.2ece9f5f321adf3587fe56b7d7159e6f.svg";
export { ForwardRef as ReactComponent };